<template>
    <div>
        <Model :is-open="actionForm.is_open">
            <template #body>
                <div class="flex-grow">
                    <div class="flex justify-between ">
                        <p class="text-lg font-medium ">
                            {{ actionForm.confirm_message }}
                        </p>
                    </div>
                </div>
            </template>
            <template #buttons>
                <div class="flex justify-end">
                    <Button @click="actionForm.is_open=false"
                            class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Cancel
                    </Button>
                    <Button @click="submitAction" class="mr-2">Yes</Button>
                </div>
            </template>
        </Model>
        <div class="flex space-x-4 mb-4 items-center"
             :class="{'justify-between': searchlink, 'justify-end': !searchlink}">
            <breeze-input v-if="searchlink" v-model="searchTable"
                          class="min-w-[220px] max-w-[420px] px-4 py-2 border border-gray-300 rounded-md mt-0"
                          placeholder="Filter Here"/>
            <div class="flex justify-between items-center space-x-4">
                <div v-if="route().current('internal.kt-students')" class="w-44">
                    <FormMultiselect
                        :required="true"
                        label=""
                        :options="courses"
                        track-key="code"
                        label-key="code"
                        :object="false"
                        v-model="selected_course"
                        returnValue="code"
                        placeholder="Course Filter"/>
                </div>
                <slot name="action_buttons"></slot>
                <Dropdown align="left" width="48" v-if="actionForm.selectedData?.length">

                    <template #trigger>
                                            <span class="inline-flex rounded-md">
                                                <button type="button"
                                                        class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out bg-gray-50 border rounded-md hover:text-gray-700 focus:outline-none">
                                                    Actions
                                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd"
                                                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                              clip-rule="evenodd"/>
                                                    </svg>
                                                </button>
                                            </span>
                    </template>

                    <template #content>
                        <button
                            class="block w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                            as="button" v-for="(item,index) in actions?.options??[]" :key="index"
                            @click="handleAction(item)">
                            {{ item.name }}
                        </button>
                    </template>
                </Dropdown>
                <breeze-button-link v-if="action && canCreate" :href="action.url">{{ action.text }}</breeze-button-link>
                <div class="flex justify-between items-center space-x-2"
                     v-if="route().current('internal.admission.list')">
                    <breeze-button @click="partial_approval = true" class="disabled:cursor-not-allowed"
                                   :class="[partial_approval ? 'bg-green-500 hover:bg-green-500' : '']"
                                   :disabled="!partial_count">
                        <slot name="partial_count"></slot>
                        partial approvals
                    </breeze-button>
                    <breeze-button class="bg-red-600 hover:bg-red-600" @click="partial_approval = false"
                                   v-if="partial_approval">
                        <Xicon class="text-white h-4 w-4"/>
                    </breeze-button>
                </div>

            </div>
        </div>
        <div class="flex flex-col w-full">
            <p v-if="actions?.options && actions.isPaginateSelect && actionForm.selectedData.length">
                Selected {{ actionForm.selectedData.length }}
            </p>
            <div class="w-full overflow-x-auto">
                <div class="inline-block w-full min-w-full py-2 align-middle" v-if="canView">
                    <div class="w-full overflow-hidden border border-gray-200 shadow sm:rounded-lg"
                         v-if="tableData.length">

                        <div class="overflow-x-auto border-b border-gray-200" ref="topScroll" @scroll="syncBodyScroll">
                            <div :style="{width: tableWidth + 'px'}" class="h-2"></div>
                        </div>
                        <div class="overflow-x-scroll" ref="tableScroll" @scroll="syncTopScroll">
                            <table class="w-full min-w-full divide-y divide-gray-200 whitespace-nowrap" ref="tableElement">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th v-if="actions?.options">
                                        <label
                                            class="flex cursor-pointer items-center gap-2 px-6 text-xs font-medium tracking-wider text-left text-gray-500 uppercase">
                                            <input
                                                class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                :checked="isChecked"
                                                type="checkbox" @change="(event)=>{
                                                if(event.target.checked){
                                                    actionForm.selectedData = [...actionForm.selectedData,...data_ids.filter((i)=>!actionForm.selectedData.includes(i))]
                                                }else {
                                                    actionForm.selectedData=actionForm.selectedData.filter((i)=>!data_ids.includes(i));
                                                }
                                            }"/></label>
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
                                        :class="field.key=='action'?'sticky right-0 bg-gray-50 z-10':''"
                                        v-for="field, index in fields" :key="index">
                                        {{ field.label }}
                                    </th>
                                </tr>
                                </thead>
                                <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="it, ind in tableData" :key="ind"
                                    :class="{'bg-red-400': it.status === false}">

                                    <th v-if="actions?.options">
                                        <div class="flex justify-start px-6">
                                            <input
                                                class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                type="checkbox" v-model="actionForm.selectedData" :value="it?.id"/>
                                        </div>
                                    </th>
                                    <td class="px-6 py-4 text-sm font-medium text-gray-900"
                                        :class="field.key=='action'?'sticky right-0 z-10 bg-white':''"    
                                        v-for="field, index in fields"
                                        :key="index">
                                        <slot :name="field.key" :item="it">{{ it[field.key] }}</slot>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div
                            class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6"
                            v-if="paginate">
                            <div class="flex justify-between flex-1 sm:hidden">
                                <a href="#"
                                   class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:text-gray-500">
                                    Previous
                                </a>
                                <a href="#"
                                   class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:text-gray-500">
                                    Next
                                </a>
                            </div>
                            <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                                <div>
                                    <p class="text-sm text-gray-700">
                                        Showing
                                        <span class="font-medium">{{ _links.from }}</span>
                                        to
                                        <span class="font-medium">{{ _links.to }}</span>
                                        of
                                        <span class="font-medium">{{ _links.total }}</span>
                                        results
                                    </p>
                                </div>
                                <div>
                                    <nav class="relative z-0 inline-flex -space-x-px rounded-md shadow-sm"
                                         aria-label="Pagination">
                                        <a :href="_links.prev_page_url"
                                           class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-l-md hover:bg-gray-50"
                                           @click.prevent="handlePageClick(_links.prev_page_url)">
                                            <span class="sr-only">Previous</span>
                                            <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                      d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                                      clip-rule="evenodd"/>
                                            </svg>
                                        </a>
                                        <a :href="link.url"
                                           class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
                                           v-for="link, index in pageLinks" :key="index"
                                           :class="{'bg-gray-50': link.active}"
                                           @click.prevent="handlePageClick(link.url)">
                                            {{ link.label }}
                                        </a>
                                        <a :href="_links.next_page_url"
                                           class="relative inline-flex items-center px-2 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-r-md hover:bg-gray-50"
                                           @click.prevent="handlePageClick(_links.next_page_url)">
                                            <span class="sr-only">Next</span>
                                            <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                                 fill="currentColor" aria-hidden="true">
                                                <path fill-rule="evenodd"
                                                      d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                                      clip-rule="evenodd"/>
                                            </svg>
                                        </a>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="py-4 overflow-hidden text-center border-b border-gray-200 shadow sm:rounded-lg" v-else>
                        {{ empty_message ?? "No Item Found" }}
                    </div>
                </div>
                <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" v-else>
                    <div class="py-4 overflow-hidden text-center border-b border-gray-200 shadow sm:rounded-lg">
                        You have no permissions
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script setup>
import {computed, nextTick, onBeforeMount, onMounted, onUnmounted, ref, watch, defineEmits} from 'vue';
import axios from 'axios';
import BreezeInput from '@/Components/Input';
import BreezeButtonLink from '@/Components/ButtonLink';
import BreezeButton from '@/Components/Button';
import Xicon from "@/Components/Icons/Xicon.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import Dropdown from "@/Components/Dropdown.vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";

import Model from "@/Components/Model.vue";
import Button from "@/Components/Button.vue";
import {getParameters, makeParameter} from "../../Utils/Common";

const actions = usePage().props.value?.actions ?? {};
const props = defineProps(['fields', 'items', 'action', 'searchlink', 'canView', 'canCreate', 'partial_count', 'courses', 'empty_message', 'isAjax']);
const searchTable = ref('');
const paginate = ref(false);
const tableData = ref([]);
const partial_approval = ref(false);
const selected_course = ref('');
const tableElement = ref(null);
const tableScroll = ref(null);
const topScroll = ref(null);
const tableWidth = ref(0);
const isKtStudentRoute = computed(() => route().current('internal.kt-students'));
const isAdmissionRoute = computed(() => route().current('internal.admission.list'));
const emit = defineEmits(['handleAction']);
const _items = computed(() => {
    tableData.value = props.items.data ?? props.items;
    updateTableWidth();
    return props.items;
});

const data_ids = computed(() => {
    return tableData.value.map((item) => item.id);
})
const isChecked = computed(() => {
    let return_value = true;
    data_ids.value.map((id) => {
        if (!actionForm.selectedData.includes(id)) {
            return_value = false;
        }
    })
    return return_value;
})
const _links = ref();
const pageLinks = computed(() => {
    const links = _links.value.links.slice();
    links.shift();
    links.pop();
    return links;
});

const getResults = (url = props.searchlink) => {
    const isCourse = isKtStudentRoute.value;
    const isAdmission = isAdmissionRoute.value;

    const params = {
        keyword: searchTable.value,
        isAjax: true,
    };
    if (isCourse) {
        params.selected_course = selected_course.value;
    }
    if (isAdmission) {
        params.partial_approval = partial_approval.value;
    }
    const useAxios = searchTable.value || (isCourse && selected_course.value) || (isAdmission && partial_approval.value);

    const query = makeParameter(false, false);
    if (!useAxios) {
        if (props?.items?.data?.data) {
            tableData.value = props.items.data?.data;
            _items.value = props.items.data;
            _links.value = props.items.data;
        } else {
            tableData.value = props.items.data ?? []
        }
    }
    if (useAxios || props.isAjax) {
        axios.get(`${url}${query}`, {params}).then(res => {
            if (res?.data?.data) {
                tableData.value = res.data?.data;
                _items.value = res.data;
                _links.value = res.data;
            } else {
                tableData.value = res.data ?? []
            }
            updateTableWidth();
        });
    } else {
        handleVisitPage(`${window.location.pathname}${query}`);
        // Inertia.visit(window.location.pathname);
    }
};


const fetchPage = (url) => {

    getResults(url);
};

const testForm = useForm({});
const handleVisitPage = (url) => {
    testForm.get(url, {
        preserveState: actions.isPaginateSelect
    });
}
const handlePageClick = (url) => {
    const query = makeParameter(false, false, false);
    const _url = `${url}${query}`;
    if (searchTable.value || partial_approval.value || selected_course.value) {
        fetchPage(_url);
    } else {
        handleVisitPage(_url);
        // window.location.href = url;
    }
};

watch(searchTable, () => getResults());
watch(partial_approval, () => getResults());
watch(selected_course, () => getResults());
watch(() => _items.value, (_new, _old) => {
    checkPagination(_new);
});

onBeforeMount(() => {
    checkPagination(_items.value);
});

onMounted(() => {
    updateTableWidth();
    window.addEventListener('resize', updateTableWidth);
});

onUnmounted(() => {
    window.removeEventListener('resize', updateTableWidth);
});

function checkPagination(data) {
    _links.value = data;
    if (data.data) {
        paginate.value = true;
        tableData.value = data.data;
    } else {
        tableData.value = data;
    }
    updateTableWidth();
}

const actionForm = useForm({
    selectedData: [],
    name: '',
    id: '',
    modal: '',
    action: actions?.action ?? '',
    controller: actions?.controller ?? '',
    is_open: false,
    handleActions: false,
    confirm_message: '',
});
const handleAction = (item) => {
    actionForm.name = item.name;
    actionForm.id = item.id;
    actionForm.handleActions = item?.handleActions ?? false;
    actionForm.modal = item.modal;
    if (item?.isEmit) {
        emit('handleAction', {
            url: route('actions'),
            form: actionForm.data(),
        })
    } else if (item.confirm) {
        actionForm.is_open = true;
        actionForm.confirm_message = item?.message ?? 'Are You Sure Perform the Bulk Action?';
    } else {
        submitAction();
    }
}

const submitAction = () => {
    actionForm.post(route('actions'), {
        onSuccess: () => {
            actionForm.is_open = false;
            actionForm.selectedData = [];
        }
    });
}

function updateTableWidth() {
    nextTick(() => {
        tableWidth.value = tableElement.value?.scrollWidth ?? 0;
    });
}

function syncBodyScroll() {
    if (tableScroll.value && topScroll.value) {
        tableScroll.value.scrollLeft = topScroll.value.scrollLeft;
    }
}

function syncTopScroll() {
    if (tableScroll.value && topScroll.value) {
        topScroll.value.scrollLeft = tableScroll.value.scrollLeft;
    }
}

</script>
